import * as Yup from 'yup';
import { MONEY_REGEX } from '@/helpers/common';
import { prettyMoney } from '@scramble/utils';

export const MIN_NON_SEPA_WITHDRAW_AMOUNT = 500;

export const VALIDATION_SCHEMA = (t, balance, hasAccounts) =>
  Yup.object()
    .shape({
      destination: Yup.object().shape({
        id: Yup.number().required(),
      }),
      amount: hasAccounts
        ? Yup.string()
            .matches(MONEY_REGEX, t('validation:val_enter_valid_amount'))
            .test(
              'min-amount',
              t('validation:val_enter_valid_amount'),
              val => Number(val) > 0,
            )
            .test(
              'max-amount',
              t('validation:val_amount_exceeds_balance', {
                amount: prettyMoney(balance),
              }),
              val => Number(val) <= balance,
            )
            .required(t('validation:val_please_enter_amount'))
        : Yup.string(),
    })
    .test('non-sepa-minimum', '', function (values) {
      if (!hasAccounts) return true;
      const { amount, destination } = values;
      if (
        !destination?.is_sepa &&
        Number(amount) < MIN_NON_SEPA_WITHDRAW_AMOUNT
      ) {
        return this.createError({
          path: 'amount',
          message: t('validation:val_withdrawal_non_sepa_min', {
            amount: MIN_NON_SEPA_WITHDRAW_AMOUNT,
          }),
        });
      }
      return true;
    });